import React from "react";

/* Stylised Bremen Town Musicians silhouette (donkey, dog, cat, rooster stacked) */
export const Stadtmusikanten = ({ className = "", color = "#062B52", ...rest }) => (
  <svg
    viewBox="0 0 200 260"
    className={className}
    fill="none"
    aria-hidden="true"
    {...rest}
  >
    <g fill={color}>
      {/* rooster */}
      <path d="M96 14c4-6 11-8 16-5 3 2 4 5 3 8 5 1 9 5 10 10 1 6-2 11-7 14l-3 2 7 7-10 1-5-5-8 3-5-6 2-9-4-5c-2-3-1-8 4-10l0 0zm16 2c-2 0-4 2-4 4h8c0-2-2-4-4-4z" />
      <path d="M84 36c-7 2-13 7-14 13 7-1 13-3 18-6l-4-7z" />
      {/* cat */}
      <path d="M78 58c3-5 9-8 15-8 7 0 13 3 16 9l4-9 3 10c4 3 6 8 6 13 0 10-9 18-21 18H88c-11 0-19-7-19-16 0-6 3-11 8-14l-3-11 4 8z" />
      <path d="M118 84c6 1 12 5 16 11l-6 3c-3-5-7-9-12-11l2-3z" />
      {/* dog */}
      <path d="M62 108c4-9 13-15 24-15h22c14 0 25 9 25 21 0 12-11 21-25 21H86c-14 0-25-9-25-21 0-2 0-4 1-6z" />
      <path d="M58 104c-5 1-9 6-9 12s4 11 10 12l2-7c-3-1-5-3-5-5s2-4 4-5l-2-7z" />
      <path d="M134 128c8 2 14 7 18 14l-6 3c-3-6-8-10-14-12l2-5z" />
      {/* donkey */}
      <path d="M40 162c0-14 13-25 30-25h50c18 0 31 11 31 26v70h-16v-46c-6 4-13 6-21 6H74c-6 0-12-1-17-4v44H41v-71z" />
      <path d="M36 152c-6-10-5-24 2-30 4 10 6 19 6 27l-8 3zM158 152c6-10 5-24-2-30-4 10-6 19-6 27l8 3z" />
      {/* plinth */}
      <path d="M18 236h164v10H18zM26 246h148v12H26z" />
    </g>
  </svg>
);

/* Minimal Bremen skyline: cathedral twin towers, Rathaus gable, Weser bridge */
export const BremenSkyline = ({ className = "", color = "#062B52", ...rest }) => (
  <svg
    viewBox="0 0 1200 220"
    className={className}
    fill="none"
    preserveAspectRatio="xMidYMax meet"
    aria-hidden="true"
    {...rest}
  >
    <g fill={color}>
      {/* windmill */}
      <path d="M40 220v-62h34v62H40zm17-72-30-28 4-5 26 24 26-24 4 5-30 28z" />
      {/* row houses */}
      <path d="M110 220v-58l20-18 20 18v58h-40zm50 0v-46l18-16 18 16v46h-36z" />
      {/* cathedral twin towers */}
      <path d="M258 220V96h26V74l12-54 12 54v22h8V74l12-54 12 54v22h26v124H258zm32-108h18v24h-18v-24zm50 0h18v24h-18v-24zM290 150h18v30h-18v-30zm50 0h18v30h-18v-30z" />
      {/* rathaus gable */}
      <path d="M420 220v-78h12l10-18 10 18h12l10-18 10 18h12l10-18 10 18h12v78H420zm24-48h16v24h-16v-24zm44 0h16v24h-16v-24z" />
      {/* church spire */}
      <path d="M576 220v-84l16-46 16 46v84h-32z" />
      {/* bridge over Weser */}
      <path d="M660 220v-8h420v8H660zm34-8V140h8v72h-8zm378 0V140h8v72h-8z" />
      <path d="M690 142c90-54 206-54 298 0l-4 7c-88-50-202-50-290 0l-4-7z" />
      <path d="M760 212v-50h6v50h-6zm60 0v-62h6v62h-6zm60 0v-66h6v66h-6zm60 0v-62h6v62h-6zm60 0v-50h6v50h-6z" />
      {/* warehouse blocks */}
      <path d="M1110 220v-70h34v70h-34zm44 0v-52h30v52h-30z" />
    </g>
  </svg>
);

export const SnowflakeMark = ({ className = "", color = "#FFFFFF", ...rest }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true" {...rest}>
    <g stroke={color} strokeWidth="2.2" strokeLinecap="round">
      <path d="M32 4v56M8 18l48 28M56 18 8 46" />
      <path d="M32 14l-7-7M32 14l7-7M32 50l-7 7M32 50l7 7" />
      <path d="M18 24l-9.5-1M18 24l-1-9.5M46 40l9.5 1M46 40l1 9.5" />
      <path d="M46 24l9.5-1M46 24l1-9.5M18 40l-9.5 1M18 40l-1 9.5" />
    </g>
  </svg>
);

/* Logo mark for favicon-style usage: snowman + shovel */
export const SnowmanMark = ({ className = "", ...rest }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true" {...rest}>
    <circle cx="26" cy="42" r="15" fill="#fff" stroke="#062B52" strokeWidth="3" />
    <circle cx="26" cy="22" r="10" fill="#fff" stroke="#062B52" strokeWidth="3" />
    <path d="M14 13h24v4H14zM19 4h14v9H19z" fill="#062B52" />
    <path d="M36 21l10 3-10 3z" fill="#FF6B00" />
    <path d="M18 31c4 4 12 4 16 0" stroke="#062B52" strokeWidth="2.6" strokeLinecap="round" />
    <circle cx="22" cy="20" r="1.8" fill="#062B52" />
    <circle cx="31" cy="20" r="1.8" fill="#062B52" />
    <path d="M16 32c-2 4-2 7 0 10l20-2c2-4 2-7 0-10l-20 2z" fill="#FF6B00" />
    <path d="M48 20h8v12h-8z" fill="#062B52" />
    <path d="M51 32h2v26h-2z" fill="#062B52" />
  </svg>
);

export const CheckBadge = ({ className = "" }) => (
  <span
    className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white ${className}`}
  >
    <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none">
      <path
        d="M5 12.5l4.5 4.5L19 7.5"
        stroke="#FF6B00"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
